/**
 * Pick Power Source — selection UI + ATC validation.
 * Companion line items are added with the main product in product-form.js
 * so the cart drawer refreshes once with every line.
 */
if (!customElements.get('power-packs')) {
  class PowerPacks extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.list = this.querySelector('.power-packs__list');
      this.errorEl = this.querySelector('.power-packs__error');
      this.productSection = this.closest('.js-product');
      this.form = this.productSection?.querySelector('.js-product-form-main');

      this.onListChange = () => this.handleChange();
      this.onFormSubmit = (evt) => this.handleFormSubmit(evt);
      this.onVariantChange = () => this.clearSelection();

      this.list?.addEventListener('change', this.onListChange);

      if (this.form) {
        this.form.addEventListener('submit', this.onFormSubmit, true);
      }

      this.productSection?.addEventListener('on:variant:change', this.onVariantChange);

      // Ensure no default (including browser-restored) selection on mount / length change.
      this.clearSelection();
    }

    disconnectedCallback() {
      this.list?.removeEventListener('change', this.onListChange);
      this.form?.removeEventListener('submit', this.onFormSubmit, true);
      this.productSection?.removeEventListener('on:variant:change', this.onVariantChange);
    }

    clearSelection() {
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = false;
      });
      this.hideError();
      this.syncSelectedClass();
    }

    handleChange() {
      this.hideError();
      this.syncSelectedClass();
    }

    syncSelectedClass() {
      this.querySelectorAll('.power-packs__option').forEach((option) => {
        const input = option.querySelector('input[type="radio"]');
        option.classList.toggle('is-selected', Boolean(input?.checked));
      });
    }

    getSelectedInput() {
      return this.querySelector('input[type="radio"]:checked');
    }

    /**
     * @returns {string|null} Selected pack variant id, or null for opt-out / none.
     */
    getSelectedPackVariantId() {
      const input = this.getSelectedInput();
      if (!input || input.value === '-1') return null;
      return input.dataset.packVariantId || null;
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.hidden = false;
      if (message) this.errorEl.textContent = message;
    }

    hideError() {
      if (this.errorEl) this.errorEl.hidden = true;
    }

    hasPowerOptions() {
      return this.querySelectorAll('input[type="radio"]').length > 0;
    }

    /**
     * Validate before product-form submit handler runs.
     * @param {SubmitEvent} evt
     */
    handleFormSubmit(evt) {
      if (!this.hasPowerOptions()) return;

      if (!this.getSelectedInput()) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        this.showError('Please pick a power source');
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      this.hideError();
    }
  }

  customElements.define('power-packs', PowerPacks);
}
